@if (profile$ | async; as profile) {
    @if (profileFields$ | async; as profileFields) {
        @if (profileFields.length > 0) {
            <section [id]="profile.Id">
                <h4 class="sh-accentuate-title">{{ profile.Name }}</h4>
                <dl class="sh-description-list">
                    @for (profileField of profileFields$ | async; track profileField) {
                        @if (profileField.hasOwnProperty("FieldDefinition")) {
                            <sh-generic-readonly-field [profileField]="profileField" [aiProfile]="aiProfile" [record]="record"></sh-generic-readonly-field>
                        } @else {
                            <dt class="sh-description-list__term">{{ profileField.DisplayLabel }}</dt>
                            <dd class="sh-description-list__details">
                                {{ "form.error.fielddefinition-not-found" | translate: { id: profileField.FieldDefinitionId } }}
                            </dd>
                        }
                    }
                </dl>
            </section>
        }
    }
}
